<template>
  <div>
    {{ GetLogin }}
    <!--<div  v-bind:style="{ 'width':'100%','height':this.windowSize.height-20+'px','border': '2px solid #000000'  }" >  -->
    <div
      v-bind:style="{ width: '100%', height: this.windowSize.height - sizeOnrefom + 'px', border: '2px solid #000000' }"
    >
      <v-img height="100%" src="../assets/Baselogin.jpg" style="backgroud-color: white" width="100%">
        <br />
        <v-container class="pa-0 ma-0 py-0 my-0 px-3">
          <img height="18%" src="../assets/log.png" style="backgroud-color: white" width="18%" />
        </v-container>

        <v-row>
          <!-- columna 1 -->
          <v-col cols="0" md="2" sm="2"></v-col>
          <!-- fn columna 1 -->
          <!--  columna 2 -->
          <v-col cols="12" md="8" sm="8">
            <center style="margin-top: -46px">
              <v-container>
                <v-card color="grey lighten-3">
                  <v-toolbar color="grey darken-2" dense flat style="border: 1px solid #000000">
                    <div>
                      <v-avatar size="45" tile>
                        <i class="fa fa-users" style="font-size: 30px; color: #ffffff"></i>
                        <!-- <img
                          src="@/assets/iconos_micromarket/custom-reports.png"
                          alt="Reporte"
                        > -->
                      </v-avatar>
                      <span class="font-weight-light" style="font-size: 18px; color: #ffffff">
                        <b>Iniciar Sesión</b>
                      </span>
                    </div>
                    <v-spacer></v-spacer>
                    <!-- <div class="d-flex justify-end"></div> -->

                    <v-btn small style="margin-right: 30px" text width="25%" @click="dialogPassOlvidada = true">
                      <span style="text-decoration-line: underline; color: #ffffff; font-size: 9px">
                        Olvidaste tu contraseña
                      </span>
                    </v-btn>

                    <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
                    <!-- style="color:white;" -->
                    <!-- <i class=""> </i> -->

                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-btn
                      color="grey darken-4"
                      fab
                      small
                      @click="cerrarmodalcuenta"
                    >
                     <i  style="font-size: 20px; color:white;" class="fa fa-close"></i>
                    </v-btn> -->
                  </v-toolbar>

                  <hr />

                  <v-container style="border: 1px solid #000000">
                    <v-form ref="formLogin" v-model="valid" lazy-validation @submit.prevent="">
                      <v-row>
                        <!-- columna 1 -->
                        <v-col cols="12" md="12" sm="12">
                          <!-------------------------------------------------- nombe login -->

                          <v-text-field
                            id="username"
                            v-model="Login.username"
                            :disabled="loading"
                            :rules="[$rules.required]"
                            autocomplete="off"
                            dense
                            label="Usuario:"
                            outlined
                            @keyup.enter="inicioSesion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-user" style="font-size: 20px"></i>
                            </template>
                          </v-text-field>

                          <!-------------------------------------------------- Pass -->

                          <v-text-field
                            id="password"
                            v-model="Login.password"
                            :disabled="loading"
                            :rules="[$rules.required]"
                            autocomplete="off"
                            dense
                            label="Contraseña:"
                            outlined
                            type="password"
                            @keyup.enter="inicioSesion"
                          >
                            <template v-slot:prepend>
                              <i class="fa fa-unlock-alt" style="font-size: 20px"></i>
                            </template>
                          </v-text-field>
                        </v-col>
                        <!-- fn columna 1 -->

                        <v-col cols="12" md="12" sm="12" style="margin-top: -25px">
                          <!-- <v-list-item-content> color:#FFFFFF </v-list-item-content>  dialogNewConfigGeneral,dialogNewRegistro-->
                          <h4 class="font-weight-light" style="color: #424242"><b>No tienes cuenta?</b></h4>

                          <v-btn
                            class="text-decoration-underline"
                            small
                            text
                            width="25%"
                            @click="dialogSessionAdmin = true"
                          >
                            <span style="text-decoration-line: underline">Registrate aquí</span>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>

                  <hr />

                  <v-toolbar class="d-flex justify-center" color="#BDBDBD" dense flat style="border: 1px solid #000000">
                    <v-btn-toggle dense rounded>
                      <v-btn
                        id="loginButton"
                        :disabled="loading"
                        :loading="loading"
                        color="#3c3b3a"
                        @click.prevent="inicioSesion"
                      >
                        <i class="fa fa-sign-in" style="font-size: 28px; color: #ffffff"></i>

                        <span style="color: #ffffff">Login</span>

                        <template v-slot:loader>
                          <span class="custom-loader">
                            <i class="fa fa-refresh" light style="font-size: 28px; color: #424242"></i>

                            <!-- <v-icon light>cached</v-icon> -->
                          </span>
                        </template>
                      </v-btn>
                    </v-btn-toggle>
                  </v-toolbar>
                </v-card>
              </v-container>
            </center>
          </v-col>
          <!-- fn columna 2 -->

          <!--  columna 3 -->
          <v-col cols="0" md="2" sm="2"></v-col>
          <!-- fn columna 3 -->
        </v-row>

        <!-- <v-snackbar
              v-model="snackbarFooter"
                :multi-line="false"
                :timeout="0"
            >


              <template v-slot:action="{ attrs }">
                <v-btn
                  color="red"
                  text
                  v-bind="attrs"
                  @click="snackbarFooter = false"
                >
                  Close
                </v-btn>
              </template>
            </v-snackbar> -->
      </v-img>

      <!-- modales -->

      <!-- ------------------------------------------------------ Modal New Configuracion Generarl -->
      <v-dialog
        v-model="dialogNewConfigGeneral"
        fullscreen
        hide-overlay
        persistent
        transition="dialog-bottom-transition"
      >
        <ComponentNewConfigGeneral @CloseConfig="dialogNewConfigGeneral = false" />
      </v-dialog>
      <!-- ------------------------------------------------------ fn Modal New Configuracion Generarl -->

      <!-- ------------------------------------------------------ fn Modal Pass Admin -->

      <v-dialog
        v-model="dialogSessionAdmin"
        label="Modal Otros Ingresos"
        max-height="80%"
        max-width="60%"
        min-width="45%"
        persistent
        transition="fab-transition"
      >
        <SesionAdmin
          @CloseSession="dialogSessionAdmin = false"
          @inicioSession=";(dialogNewConfigGeneral = true), (dialogSessionAdmin = false)"
        />
      </v-dialog>
      <!-- ------------------------------------------------------ fn Modal New Configuracion Generarl -->

      <!-- ------------------------------------------------------ Modal New registro -->

      <v-dialog v-model="dialogNewRegistro" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar color="grey darken-2" dark>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-toolbar-title v-on="on">Registrate</v-toolbar-title>
              </template>
              <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                <span>Registro:</span>
                Creación de usuario
              </i>
            </v-tooltip>

            <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

            <v-spacer></v-spacer>

            <v-card-actions>
              <v-sheet
                id="scrolling-techniques-7"
                :max-width="windowSize.width - 70"
                class="overflow-x-auto"
                color="transparent"
              >
                <v-btn-toggle>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="#90A4AE" dark small @click="NewRegistro" v-on="on">
                        <i class="fa fa-file-o" style="font-size: 20px"></i>
                        Limpiar
                      </v-btn>
                    </template>
                    <span>Limpiar</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn id="boton-mini" color="success" dark small @click="saveRegistro" v-on="on">
                        <i class="fa fa-check-circle" style="font-size: 20px"></i>
                        <!-- fab x-small dark  -->
                        SALVAR
                      </v-btn>
                    </template>
                    <span>Guardar Registro</span>
                  </v-tooltip>

                  <!-- <v-tooltip top>
                  <template v-slot:activator="{ on }">
                     <v-btn id="boton-mini" v-on="on" @click="removeComponentsNotaCredito" color="red"  small  dark>
                      <i style="font-size: 20px;" class="fa fa-trash"> </i>
                      ELIMINAR </v-btn>
                   </template>
                            <span>Eliminar configuración</span>
                    </v-tooltip> -->
                </v-btn-toggle>
              </v-sheet>
            </v-card-actions>

            <v-btn color="grey darken-4" fab small @click="cerrarRegistro">
              <i class="fa fa-close" style="font-size: 20px; color: white"></i>
            </v-btn>
          </v-toolbar>

          <v-list subheader three-line>
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="grey darken-2" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <i class="fa fa-pencil-square-o" style="font-size: 30px; color: #ffffff"></i>
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px; color: #ffffff">
                    <b>Registro de Usuario</b>
                  </span>
                </v-toolbar>

                <v-container style="border: 1px solid #000000">
                  <v-form ref="formRegistro" v-model="valid" lazy-validation>
                    <input v-model="registro.codigo" style="display: none" type="number" />
                    <v-row>
                      <!-- fila 1 ------------------------------>
                      <v-col cols="12" md="12" sm="12">
                        <!-- Nombre:-->
                        <v-text-field
                          v-model="registro.nombre"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="Nombre:"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-font" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- Nombre:-->
                        <v-text-field
                          v-model="registro.usuario"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="usuario:"
                          outlined
                          @blur="validarIduser"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-font" style="font-size: 20px"></i>
                          </template>

                          <template v-slot:append-outer>
                            <!-- <v-tooltip top>
                            <template v-slot:activator="{ on }">
                            <i v-if="ValidIdUser==true" v-on="on" style="font-size: 30px; color:#F44336; " class="fa fa-times"></i>
                            </template>
                    <span>El Usuario ya existe agregado</span>
                    </v-tooltip> -->

                            <i
                              v-if="ValidIdUser == true"
                              class="fa fa-times"
                              style="font-size: 30px; color: #f44336"
                              v-on="on"
                            ></i>
                            <i
                              v-if="ValidIdUser == false"
                              class="fa fa-check"
                              style="font-size: 30px; color: #4caf50"
                            ></i>
                          </template>
                        </v-text-field>

                        <!-- contraseña:-->
                        <v-text-field
                          v-model="registro.clave"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="clave:"
                          outlined
                          type="password"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-unlock-alt" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <!-- contraseña:-->
                        <v-text-field
                          v-model="ContraseñaConfirmacion"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="Confirmación:"
                          outlined
                          type="password"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-unlock-alt" style="font-size: 20px"></i>
                          </template>

                          <template v-slot:append-outer>
                            <i
                              v-if="registro.clave != ContraseñaConfirmacion"
                              class="fa fa-times"
                              style="font-size: 30px; color: #f44336"
                            ></i>
                            <i
                              v-if="registro.clave == ContraseñaConfirmacion"
                              class="fa fa-check"
                              style="font-size: 30px; color: #4caf50"
                            ></i>
                          </template>
                        </v-text-field>

                        <!-- -----------------------------  email -->
                        <v-text-field
                          v-model="registro.correo"
                          :rules="[$rules.email]"
                          dense
                          label="E-mail"
                          outlined
                          @blur="validarEmail"
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-envelope-o" style="font-size: 20px"></i>
                          </template>

                          <template v-slot:append-outer>
                            <!-- <v-tooltip top>

                            <template v-slot:activator="{ on }">
                            <i v-if="ValidEmail==true" v-on="on" style="font-size: 30px; color:#F44336; " class="fa fa-times"></i>
                            </template>
                    <span>El correo ya existe agregado</span>
                    </v-tooltip> -->

                            <i
                              v-if="ValidEmail == true"
                              class="fa fa-times"
                              style="font-size: 30px; color: #f44336"
                            ></i>
                            <i
                              v-if="ValidEmail == false"
                              class="fa fa-check"
                              style="font-size: 30px; color: #4caf50"
                            ></i>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="registro.palabrasecreta"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="Palabra secreta:"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-font" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-switch
                          v-model="registro.consulta"
                          class="mt-0"
                          color="teal"
                          hide-details
                          inset
                          label="Tipo de usuario:"
                        >
                          <template v-slot:label>
                            <strong v-if="registro.consulta == true" style="color: #000000">
                              Tipo de usuario: Consulta
                            </strong>
                            <strong v-if="registro.consulta == false" style="color: #000000">
                              Tipo de usuario: Reporte
                            </strong>
                          </template>
                        </v-switch>
                      </v-col>
                      <!-- fn Documentos:-->

                      <!-- fn fila 1 ------------------------------>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-list>
        </v-card>
      </v-dialog>
      <!-- fn Modal New registro----------------------------------------------------------------------------------------------->

      <!-- ------------------------------------------------------ Modal PassOlvidada -->

      <v-dialog v-model="dialogPassOlvidada" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar color="grey darken-2" dark>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-toolbar-title v-on="on">Recuperación de Contraseña</v-toolbar-title>
              </template>
              <i class="fa fa-info-circle" dark dense style="font-size: 20px">
                <span>Recuperación:</span>
                Recuperar contraseña olvidada
              </i>
            </v-tooltip>

            <!-- <v-toolbar-title>Ordenes De Compras sugeridas</v-toolbar-title> -->

            <v-spacer></v-spacer>

            <v-card-actions>
              <v-sheet
                id="scrolling-techniques-7"
                :max-width="windowSize.width - 70"
                class="overflow-x-auto"
                color="transparent"
              ></v-sheet>
            </v-card-actions>

            <v-btn color="grey darken-4" fab small @click="cerrarPassOlvidada">
              <i class="fa fa-close" style="font-size: 20px; color: white"></i>
            </v-btn>
          </v-toolbar>

          <v-list subheader three-line>
            <v-container>
              <v-card color="grey lighten-3">
                <v-toolbar color="grey darken-2" dense flat style="border: 1px solid #000000">
                  <v-avatar size="45" tile>
                    <i class="fa fa-user-secret" style="font-size: 30px; color: #ffffff"></i>
                  </v-avatar>
                  <span class="font-weight-light" style="font-size: 20px; color: #ffffff">
                    <b>Contraseña Olvidada</b>
                  </span>
                </v-toolbar>

                <v-container style="border: 1px solid #000000">
                  <v-form ref="formOlvidada" v-model="valid" lazy-validation>
                    <input v-model="passWord.codigo" style="display: none" type="number" />
                    <v-row>
                      <!-- fila 1 ------------------------------>
                      <v-col cols="12" md="12" sm="12">
                        <!-- -----------------------------  email -->
                        <v-text-field
                          v-model="passWord.correo"
                          :rules="[$rules.required, $rules.email]"
                          dense
                          label="E-mail"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-envelope-o" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="passWord.palabrasecreta"
                          :rules="[$rules.required]"
                          autocomplete="off"
                          dense
                          label="Palabra secreta:"
                          outlined
                        >
                          <template v-slot:prepend>
                            <i class="fa fa-user-secret" style="font-size: 20px"></i>
                          </template>
                        </v-text-field>

                        <v-card
                          v-if="usuario.codigo > 0"
                          class="mx-auto"
                          max-width="500"
                          outlined
                          style="border: 1px solid #000000"
                        >
                          <v-toolbar
                            class="d-flex justify-center"
                            color="grey darken-2"
                            dense
                            flat
                            style="border: 1px solid #000000"
                          >
                            <i class="fa fa-info-circle" style="font-size: 30px; color: #ffffff"></i>
                            <span class="font-weight-light" style="font-size: 20px; color: #ffffff">
                              <b>Información</b>
                            </span>
                          </v-toolbar>

                          <v-list-item three-line>
                            <v-list-item-content>
                              <v-list-item-title class="overline mb-1">
                                <b style="font-size: 20px">{{ usuario.nombre }}</b>
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                <b>Usuario:</b>
                                {{ usuario.usuario }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <b>Clave:</b>
                                {{ usuario.clave }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <b>Correo:</b>
                                {{ usuario.correo }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-avatar color="grey" size="68">
                              <v-avatar color="grey" size="68">
                                <span class="white--text headline">{{ getletra(usuario.nombre) }}</span>
                              </v-avatar>
                            </v-list-item-avatar>
                          </v-list-item>
                        </v-card>
                      </v-col>
                      <!-- fn Documentos:-->

                      <hr />

                      <v-toolbar
                        class="d-flex justify-center"
                        color="#BDBDBD"
                        dense
                        flat
                        style="border: 1px solid #000000"
                      >
                        <v-btn-toggle dense rounded>
                          <v-btn
                            :disabled="loading"
                            :loading="loading"
                            color="#3c3b3a"
                            @click.prevent="validarPassOlvidada"
                          >
                            <i class="fa fa-thumbs-up" style="font-size: 28px; color: #ffffff"></i>

                            <span style="color: #ffffff">verificar</span>

                            <template v-slot:loader>
                              <span class="custom-loader">
                                <i class="fa fa-refresh" light style="font-size: 28px; color: #424242"></i>

                                <!-- <v-icon light>cached</v-icon> -->
                              </span>
                            </template>
                          </v-btn>
                        </v-btn-toggle>
                      </v-toolbar>

                      <!-- fn fila 1 ------------------------------>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-list>
        </v-card>
      </v-dialog>
      <!-- fn Modal PassOlvidada----------------------------------------------------------------------------------------------->

      <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="grey darken-2" dark>
          <v-card-text>
            Validando Sesion...
            <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="aalert.estado"
        :color="aalert.color"
        :timeout="120000"
        :vertical="true"
        style="margin-top: 20%"
        top="top"
      >
        {{ aalert.nombre }}
        <v-btn dark text @click="aalert.estado = false">Close</v-btn>
      </v-snackbar>

      <!-- fn modales -->
    </div>
    <!-- <v-sheet id="footInfo" style="margin-top:35px;" height="150px"> -->
    <v-sheet v-if="footerInfdeca" id="footInfo" height="100px">
      <v-container class="py-0 my-0">
        <v-row no-gutters>
          <v-col class="pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
            <v-list-item-content class="pa-0 ma-0 py-0 my-0">
              <span id="labText-min" style="color: #ffffff">DECASYSTEMS, S.R.L.</span>
              <span id="labText-min" style="color: #ffffff">República Dominicana</span>
              <span id="labText-min" style="color: #ffffff">Cerros de Gurabo II, Calle 4, #12, Santiago.</span>
              <span id="labText-min" style="color: #ffffff">Teléfono: 809-247-4811</span>
            </v-list-item-content>
          </v-col>
          <v-col class="d-flex justify-end pa-0 ma-0 py-0 my-0" cols="6" md="6" sm="6">
            <!-- imgajust -->
            <v-avatar :size="60" class="ma-2">
              <img id="img-ajustada" alt="Gmail" src="../assets/Google_Mail.png" />
            </v-avatar>

            <v-avatar :size="60" class="ma-2">
              <img id="img-ajustada" alt="Face book" src="../assets/Facebook.png" />
            </v-avatar>
          </v-col>
        </v-row>
      </v-container>
      <!-- <span style="color:#FFFFFF;" >© copyright. Todos los derechos reservados. DECASYSTEMS.</span> -->
    </v-sheet>
  </div>
</template>

<script>
  import { EventBus } from "../event-bus"
  import VueAutonumeric from "../components/AutoNumericNuevo"
  import ComponentNewConfigGeneral from "@/Formularios/ConfigGeneral.vue"
  import SesionAdmin from "@/Formularios/SesionAdmin.vue"
  import { VueEasyJwt } from "vue-easy-jwt"

  const JWT = new VueEasyJwt()

  export default {
    components: {
      VueAutonumeric,
      ComponentNewConfigGeneral,
      SesionAdmin,
    },

    created() {
      sessionStorage.setItem("Usuario", JSON.stringify(null))

      var json = {
        titulo: "Login",
        descripcion: "Login",
        save: false,
        eliminar: false,
        anular: false,
        nuevo: false,
        imprimir: false,
        accion: ["LoginNew", "LoginSave", "LoginRemove", "LoginAnular", "LoginPrintList"],
      }
      EventBus.$emit("anularBotonesAccion", json)
    },

    mounted() {
      // EventBus.$on("abrirMenuizquierdo", this.abrirTabla);
      // // EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      // EventBus.$on("LoginNew", this.new);
      // EventBus.$on("LoginSave", this.save);
      // EventBus.$on("LoginRemove", this.remove);
      // EventBus.$on("LoginAnular", this.remove);
      // EventBus.$on("LoginPrintList", this.imprimirList);
      // EventBus.$on("emitLogin", this.datostabla);
      var objjct = {
        login: true,
        pv: false,
        mt: false,
      }

      EventBus.$emit("GetLogin", objjct)
      EventBus.$on("onResize", this.onResize)
    },

    data: () => ({
      dialogSessionAdmin: false,
      footerInfdeca: true,
      //sizeOnrefom: 170,
      sizeOnrefom: 110,

      Valid: true,
      ValidEmail: false,
      ValidIdUser: false,
      dialogPassOlvidada: false,
      ContraseñaConfirmacion: "",

      dialogNewRegistro: false,
      snackbarFooter: true,
      Rpropietario: [],
      RCaja: [],
      Rproducto: [],
      RCuenta: [],
      ListaTiposClientes: [],

      windowSize: { width: "auto", height: "auto" },

      imgajust: 80,

      loading: false,

      registro: {
        codigo: 0,
        nombre: "",
        usuario: "",
        clave: "",
        consulta: false,
        correo: "",
        palabrasecreta: "",
      },

      passWord: { correo: "", palabrasecreta: null },

      usuario: {
        codigo: 0,
        clave: "",
        consulta: false,
        correo: "",
        nombre: "",
        usuario: "",
      },

      Login: {
        username: null,
        password: null,
      },

      ejecucion: true,
      text: "",
      valid: true,

      dialogNewConfigGeneral: false,

      Elim_notif: {
        estado: false,
        nombre: "¿Seguro que desea anular este registro?",
      },

      aalert: {
        estado: false,
        color: null,
      },
    }),

    methods: {
      getletra(e) {
        var letra
        if (e.length > 0) {
          letra = e.substr(0, 2)
        } else {
          letra = " "
        }

        return letra
      },

      cerrarPassOlvidada() {
        this.dialogPassOlvidada = false

        this.passWord = { correo: "", palabrasecreta: "" }

        this.usuario = {
          codigo: 0,
          clave: "",
          consulta: false,
          correo: "",
          nombre: "",
          usuario: "",
        }
      },

      validarPassOlvidada() {
        if (this.$refs.formOlvidada.validate()) {
          this.$axios
            .post(
              this.$hostname + this.$hName + "/services/reportes/OlvidoContr",
              JSON.parse(JSON.stringify(this.passWord))
            )
            .then((res) => {
              if (res.data.usuario != null) {
                this.usuario = res.data.usuario
              }
              this.alerta(res.data.mensage, res.data.estado) /*, */
            })
            .catch((error) => this.alerta(error, "error"))
        } else {
          this.alerta("los campos en rojo son Requeridos", "error")
        }
      },

      validarIduser() {
        this.$axios
          .post(
            this.$hostname + this.$hName + "/services/reportes/ValidarIdUser",
            JSON.parse(JSON.stringify(this.registro))
          )
          //  .then(res => this.alerta(res.data.mensage,res.data.estado))
          .then((res) => {
            this.ValidIdUser = res.data.estado
          })
          .catch((error) => this.alerta(error, "error"))
      },

      validarEmail() {
        this.$axios
          .post(
            this.$hostname + this.$hName + "/services/reportes/ValidarEmail",
            JSON.parse(JSON.stringify(this.registro))
          )
          //  .then(res => this.alerta(res.data.mensage,res.data.estado))
          .then((res) => {
            this.ValidEmail = res.data.estado
          })
          .catch((error) => this.alerta(error, "error"))
      },

      close() {},

      onResize(e) {
        this.windowSize = e
      },

      cerrarRegistro() {
        this.dialogNewRegistro = false
      },

      NewRegistro() {
        ;(this.registro = {
          codigo: 0,
          nombre: "",
          usuario: "",
          clave: "",
          consulta: false,
          correo: "",
        }),
          (this.ejecucion = true)
      },
      saveRegistro() {
        if (this.ValidIdUser == true) {
          this.alerta("El usuario ya existe agregado", "error")
          return
        }

        if (this.ValidEmail == true) {
          this.alerta("El Correo ya existe agregado", "error")
          return
        }

        if (this.registro.clave != this.ContraseñaConfirmacion) {
          this.alerta("la clave de confirmación no coincide", "error")
          return
        }

        if (this.$refs.formRegistro.validate()) {
          if (this.ejecucion == true) {
            this.ejecucion = false

            var jsn = {
              datos: JSON.parse(JSON.stringify(this.registro)),
            }
            //http://:8080/ProyectWs/services/reportes/findallUsuario
            this.$axios
              .post(this.$hostname + this.$hName + "/services/reportes/saveOrUpdate", JSON.parse(JSON.stringify(jsn)))
              //  .then(res => this.alerta(res.data.mensage,res.data.estado))
              .then((res) => this.alerta("Dato Guardado correctamente", "bien"))
              .catch((error) => this.alerta(error, "error"))
          }
        } else {
          this.alerta("los campos en rojo son Requeridos", "error")
        }
      },

      inicioSesion() {
        if (this.$refs.formLogin.validate()) {
          this.loading = true
          setTimeout(this.validarSesion, 2000)
        }
      },

      validarSesion() {
        const data =
          "usuario=" +
          encodeURIComponent(this.Login.username) +
          "&clave=" +
          encodeURIComponent(this.Login.password)
        console.log(`url BACK--->${this.$hostname} ${this.$hName}/login/auth`)
        this.$axios
          .post(this.$hostname + this.$hName + `/login/auth`, data, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
          })
          .then((res) => {
            this.IniciadoSeccion(res.data)
          })
          .catch((error) => {
            this.loading = false

            if (error.response) {
              // Request made and server responded
              //   console.log('ECONNREFUSED')
              // console.log(error.response.request.responseText.includes('ECONNREFUSED'))
              if (error.response.request.responseText.includes("ECONNREFUSED")) {
                this.alerta("Servidor no esta disponible.", "error")
              } else {
                this.alerta(error.response.request.responseText, "error")
              }

              this.loading = false
              // console.log(error.response.status);
              // console.log(error.response.headers);
            } else if (error.request) {
              this.loading = false
              console.log("catchrequest")
              // The request was made but no response was received
              console.log(error.request)
            } else {
              this.loading = false
              console.log("ElsecatchTodo")
              console.log(error)
              // Something happened in setting up the request that triggered an Error
              console.log("Error" + error.message)
            }
            this.CerrarSesion()
          })
      },

      IniciadoSeccion(e) {
        //console.log(e)
        //jwt.decode(token.encode('UTF-8'), SECRET_KEY)

        /*var obj={
      nombre:'JéanCáarlos'
    }
    var strin='eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkrDqWhuIETDqWUiLCJpYXQiOjE1MTYyMzkwMjJ9.0BGsxaL8UWwV3ACQ2KCxX0hd5d0Dn1LbT4JRdoolgWs'
    console.log(strin)*/

        /*console.log('Vienendo INformcacion encode')
    console.log(JWT.decodeToken(strin))*/

        /*
    >>> key = "secret"
    >>> encoded = jwt.encode({"some": "payload"}, key, algorithm="HS256")
    >>> print(encoded)
    eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzb21lIjoicGF5bG9hZCJ9.4twFt5NiznN84AWoo1d7KO1T_yoc0Z6XOpOVswacPZg
    >>> jwt.decode(encoded, key, algorithms="HS256")*/

        const TOKEN = JWT.decodeToken(e.token)
        const TENANT_ID = TOKEN.tenant
        //---Ojo:Creando Variables vuex y session usuario
        //console.log(TOKEN)
        this.$store.commit("MutationHeadersAxios", e.token, TOKEN)
        this.$store.commit("MutationHeadersTenant", TENANT_ID)
        sessionStorage.setItem("AuthorizationToken", JSON.stringify(e.token))

        /* this.loading = false
     this.$router.push({ path: '/Principal' })
     this.$store.commit('MutationbtnAppBar', true);*/

        var usss = {
          imagen: "../assets/img-deca/entrenamientoB.png",
          nombre: "Jean Carlos",
          correo: "Jean@gmail.com",
          user: "Jean_22",
          ...TOKEN,
        }

        var TokeUsuario = JSON.parse(JSON.stringify(TOKEN))
        var nombreUse = TokeUsuario.usuario.nombre

        if (nombreUse != null && nombreUse.length > 0) {
          nombreUse = nombreUse.replaceAll("Ã¡", "á")
          nombreUse = nombreUse.replaceAll("Ã©", "é")
          nombreUse = nombreUse.replaceAll("Ã­", "í")
          nombreUse = nombreUse.replaceAll("Ã³", "ó")
          nombreUse = nombreUse.replaceAll("Ãº", "ú")
          // console.log('elreal Toke')
          // console.log(TOKEN.usuario.sudo)
          TokeUsuario.usuario.nombre = nombreUse
        }
        sessionStorage.setItem("Usuario", JSON.stringify(TokeUsuario))
        this.$store.commit("MutationaddUser", TokeUsuario)
        sessionStorage.setItem("ComprobanteAgotado", JSON.stringify(true))
        var permisoPvList = TokeUsuario.usuario.usuarioPermisoPvList || []
        var tienePermisoAlertaCredito = TokeUsuario.usuario.sudo === true
          || permisoPvList.some(function (item) {
            return item.fn == 16 && item.op == 50
          })
        sessionStorage.setItem("FacturasCreditoVencer", JSON.stringify(tienePermisoAlertaCredito))
        //Dia de pago
        var diaPago = new Date().getDate()
        if (diaPago >= 1 && diaPago <= 10) {
          sessionStorage.setItem("mostrarDiaPago", JSON.stringify(true))
        } else {
          sessionStorage.setItem("mostrarDiaPago", JSON.stringify(false))
        }

        this.$axios
          .get(this.$hostname + this.$hName + "/configuraciones/find", { headers: this.$store.getters.GetheadersAxios })
          .then((res) => {
            //COMENTADO POR: https://decasystem.atlassian.net/browse/MIC-3453
            //this.crearContabilidadPvNoexit()
            
            sessionStorage.setItem("ConfiguracionGeneral", JSON.stringify(res.data))
            this.$store.commit("MutationaddConfiguracionGeneral", res.data)

            // var ConfOtros = JSON.parse(sessionStorage.getItem("OtrasConfigPv"))
            // if (ConfOtros != null) {
            //   this.$store.commit('MutationDataOtrasConfigPv', ConfOtros);
            // }else{}

            var cj = null
            if (localStorage.hasOwnProperty("caja")) {
              var c = JSON.parse(localStorage.caja)
              cj = c.descripcion.trim()
            }

            var impre = null
            if (localStorage.hasOwnProperty("printerSelect")) {
              var impre = JSON.parse(localStorage.printerSelect)
            }

            var obj = {
              caja: cj,
              cajero: TOKEN.usuario.nombre != null ? TOKEN.usuario.nombre : TOKEN.usuario.username,
              moneda: res.data.config.monedabase.descripcion.trim(),
              impresora: impre,
              terminal: null,
              turno: null,
            }
            //this.$store.commit("MutationDataOtrasConfigPv", this.OtrasConfigPv);
            sessionStorage.setItem("OtrasConfigPv", JSON.stringify(obj))
            this.$store.commit("MutationDataOtrasConfigPv", obj)

            if (TOKEN.usuario.sudo == true) {
              this.loading = false
              this.$router.push({ path: "/Principal" })
              this.$store.commit("MutationbtnAppBar", true)

              let routes = this.$store.getters.GetDatosItemsRouterDefour
              if (!TOKEN.usuario.accesoUtilitario) {
                let tempRoutes = this.$store.getters.GetDatosItemsRouterDefour
                tempRoutes.filter((route) => route.codigo == 11)[0].items = tempRoutes
                  .filter((route) => route.codigo == 11)[0]
                  .items.filter((r2) => !r2.title.includes("Utilitario"))
                routes = tempRoutes
              }

              this.distribuidoraFarmaceuticaRoutes(routes)
              routes = this.estacionRoutes(routes)

              var bool = this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico
              if (bool) {
                if (
                  routes.filter((route) => route.codigo == 3).length > 0 &&
                  routes.filter((route) => route.codigo == 3)[0].items.filter((items) => items.codigo == 245).length > 0
                ) {
                  routes.filter((route) => route.codigo == 3)[0].items.filter((items) => items.codigo == 245)[0].link =
                    "/pv/FacturacionComercialDistFarma"
                }
              }
              sessionStorage.setItem("itemsRouter", JSON.stringify(routes))
              this.$store.commit("MutationDataRouter", routes)
            } else {
              this.CrearRouter(TOKEN)
            }

            this.getFacturaeletronicaPendiente()
          })
          .catch((error) => {
            this.loading = false
            this.alerta(`configuraciones: ${error}`, "error")
            this.CerrarSesion()
          })
      },

      CrearRouter(e) {
        this.$axios
          .post(this.$hostname + this.$hName + "/usuario/menuDisponible", e.usuario, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            var menuDisponible = Array.isArray(res.data) ? res.data : []
            var sesion = this.$store.getters.GetdatosInfUsu
            if (sesion != null && sesion.usuario != null) {
              this.$set(sesion.usuario, "menuDisponible", menuDisponible)
              this.$store.commit("MutationaddUser", sesion)
              sessionStorage.setItem("Usuario", JSON.stringify(sesion))
            }
            this.loading = false
            if (!e.usuario.lectorPrecio) {
              this.$router.push({ path: "/Principal" })
            } else {
              this.$router.push({ path: "/pv/verprecioproductos" })
            }
            this.$store.commit("MutationbtnAppBar", true)
            this.CrearRouterContinuar(menuDisponible)
          })
          .catch((error) => {
            this.alerta("Dato no guardado correctamente", "error")
          })
      },

      CrearRouterContinuar(eo) {
        var rou = this.$store.getters.GetDatosItemsRouterDefour
        var CrearRow = []
        var buscarMenuPorCodigo = function(items, codigo) {
          for (var i = 0; i < items.length; i++) {
            if (items[i].codigo == codigo) {
              return { item: items[i], grupo: null }
            }
            if (items[i].items) {
              for (var x = 0; x < items[i].items.length; x++) {
                if (items[i].items[x].codigo == codigo) {
                  return { item: items[i].items[x], grupo: items[i] }
                }
              }
            }
          }
          return null
        }
        var agregarMenuPermitido = function(moduloDestino, menuEncontrado) {
          if (!menuEncontrado) {
            return
          }
          if (menuEncontrado.grupo) {
            var grupoDestino = moduloDestino.items.filter((e) => e.codigo == menuEncontrado.grupo.codigo)[0]
            if (!grupoDestino) {
              grupoDestino = JSON.parse(JSON.stringify(menuEncontrado.grupo))
              grupoDestino.items = []
              moduloDestino.items.push(grupoDestino)
            }
            if (grupoDestino.items.filter((e) => e.codigo == menuEncontrado.item.codigo).length == 0) {
              grupoDestino.items.push(JSON.parse(JSON.stringify(menuEncontrado.item)))
            }
            grupoDestino.items.sort(function (a, b) {
              if (a.orden > b.orden) {
                return 1
              }
              if (a.orden < b.orden) {
                return -1
              }
              return 0
            })
          } else if (moduloDestino.items.filter((e) => e.codigo == menuEncontrado.item.codigo).length == 0) {
            moduloDestino.items.push(JSON.parse(JSON.stringify(menuEncontrado.item)))
          }
        }
        eo.forEach((ele) => {
          var objModulo = rou.filter((e) => e.codigo == ele.modulo.codigo)
          var ObjCrearRow = CrearRow.filter((e) => e.codigo == ele.modulo.codigo)

          if (ObjCrearRow.length == 0) {
            var objsub = JSON.parse(JSON.stringify(objModulo[0]))
            objsub.items = []

            if (ele.nombre.includes("Reportes")) {
              var subMen = buscarMenuPorCodigo(objModulo[0].items, 1000)
              agregarMenuPermitido(objsub, subMen)
            } else {
              var subMen = buscarMenuPorCodigo(objModulo[0].items, ele.codigo)
              agregarMenuPermitido(objsub, subMen)
            }
            CrearRow.push(objsub)
          }

          if (ObjCrearRow.length > 0) {
            var objsub = JSON.parse(JSON.stringify(objModulo[0]))
            if (ele.nombre.includes("Reportes")) {
              var subMen = buscarMenuPorCodigo(objsub.items, 1000)
              agregarMenuPermitido(CrearRow.filter((e) => e.codigo == ele.modulo.codigo)[0], subMen)
            } else {
              var subMen = buscarMenuPorCodigo(objsub.items, ele.codigo)
              agregarMenuPermitido(CrearRow.filter((e) => e.codigo == ele.modulo.codigo)[0], subMen)
            }

            CrearRow.filter((ee) => ee.codigo == ele.modulo.codigo)[0].items.sort(function (a, b) {
              if (a.orden > b.orden) {
                return 1
              }
              if (a.orden < b.orden) {
                return -1
              }
              return 0
            })
          }
        })

        this.distribuidoraFarmaceuticaRoutes(CrearRow)
        CrearRow = this.sudoUserRoutes(CrearRow)
        CrearRow = this.estacionRoutes(CrearRow)

        CrearRow.sort(function (a, b) {
          if (a.orden > b.orden) {
            return 1
          }
          if (a.orden < b.orden) {
            return -1
          }
          return 0
        })

        var BOOLROUT = this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico
        if (BOOLROUT) {
          if (
            CrearRow.filter((route) => route.codigo == 3).length > 0 &&
            CrearRow.filter((route) => route.codigo == 3)[0].items.filter((items) => items.codigo == 245).length > 0
          ) {
            CrearRow.filter((route) => route.codigo == 3)[0].items.filter((items) => items.codigo == 245)[0].link =
              "/pv/FacturacionComercialDistFarma"
          }
        }

        var USU=this.$store.getters.GetdatosInfUsu.usuario
        if (USU.hasOwnProperty('accesoUtilitario') && USU.accesoUtilitario==true) {
             /*console.log('No-sudo-ver-CrearRow->',eo)
              console.log('No-sudo-ver-CrearRow->',CrearRow)
             console.log('User--->',USU.accesoUtilitario)*/

           let tpRoutes =   CrearRow.filter((route) => route.codigo == 11)
           var ITEM_UTI= rou.filter((route) => route.codigo == 11)[0].items.filter((r2) => r2.title.includes("Utilitario"))
            console.log('ver-ITEM_UTI->',ITEM_UTI)
           if(tpRoutes.length>0){
              CrearRow.filter((route) => route.codigo == 11)[0].items.push(ITEM_UTI[0])
           }else{

            var SEG_UTIL={
              codigo : 11,
              orden : 19,
              Opcion : "Seguridad",
              icon : "iconos_micromarket/seg.png",
              items:ITEM_UTI
            }
           CrearRow.push(SEG_UTIL)
            //CrearRow.filter((route) => route.codigo == 11)[0].items.push(ITEM_UTI[0])
           }

           

        }
        //eo.usuario.accesoUtilitario
      
   

        sessionStorage.setItem("itemsRouter", JSON.stringify(CrearRow))
        this.$store.commit("MutationDataRouter", CrearRow)
      },

      /*
    Verifica si el usuario es SUDO
    Devuelve las rutas a las que puede acceder dependiendo de su configuracion
   */
      sudoUserRoutes(menu) {
        if (!this.$store.getters.GetdatosInfUsu.sudo) {
          menu.forEach((modulo) => {
            modulo.items = modulo.items.filter((item) => item.codigo !== 24)
          })
          return menu
        }
        return menu
      },

      /*
    Verifica si el usuario es una estacion
    Devuelve las rutas a las que puede acceder dependiendo de su configuracion
   */
      estacionRoutes(menu) {
        const isEstacion =
          this.$store.getters.GetConfiguracionGeneral.config.estacion ||
          this.$store.getters.GetConfiguracionGeneral.config.estacionCombustible

        if (!isEstacion) {
          return menu.filter((modulo) => modulo.codigo !== 13)
        }
        return menu
      },

      /*
  Verifica si el usuario es una distribuidora farmaceutica
  Devuelve las rutas a las que puede acceder dependiendo de su configuracion
   */
      distribuidoraFarmaceuticaRoutes(menu) {
        if (!this.$store.getters.GetConfiguracionGeneral.config.distribuidoraFarmaceutico) {
          menu.forEach((modulo) => {
            if (modulo.items) {
              modulo.items = modulo.items.filter((item) => item.codigo !== 258 && item.codigo !== 260)
              modulo.items.forEach((item) => {
                if (item.items) {
                  item.items = item.items.filter((subitem) => subitem.title !== "Descuentos Indebidos")
                }
              })
            }
          })
        }
      },

      CrearRouter1(e) {
        var rou = this.$store.getters.GetDatosItemsRouterDefour
        var CrearRow = []

        e.usuario.menuDisponible.forEach((ele) => {
          rou.forEach((element) => {
            var ObjCrearRow = element.items.filter((ee) => ee.codigo == ele.codigo)
            if (ObjCrearRow.length > 0) {
              var ObjMenu = CrearRow.filter((ee) => ee.codigo == element.codigo)
              if (ObjMenu.length > 0) {
                CrearRow.filter((ee) => ee.codigo == element.codigo)[0].items.push(ObjCrearRow[0])
                CrearRow.filter((ee) => ee.codigo == element.codigo)[0].items.sort(function (a, b) {
                  if (a.orden > b.orden) {
                    return 1
                  }
                  if (a.orden < b.orden) {
                    return -1
                  }
                  return 0
                })
              } else {
                var objModulo = JSON.parse(JSON.stringify(element))
                objModulo.items = JSON.parse(JSON.stringify(ObjCrearRow))
                CrearRow.push(objModulo)
              }
            }
          })
        })

        CrearRow.sort(function (a, b) {
          if (a.orden > b.orden) {
            return 1
          }
          if (a.orden < b.orden) {
            return -1
          }
          return 0
        })
        sessionStorage.setItem("itemsRouter", JSON.stringify(CrearRow))
        this.$store.commit("MutationDataRouter", CrearRow)
      },

      CrearRouter2(e) {
        var rou = this.$store.getters.GetDatosItemsRouterDefour
        var CrearRow = []

        e.usuario.menuDisponible.forEach((ele) => {
          var obj = rou.filter((e) => e.codigo == ele.modulo.codigo)
          var ObjCrearRow = CrearRow.filter((e) => e.codigo == ele.modulo.codigo)

          if (ObjCrearRow.length == 0) {
            var objsub = JSON.parse(JSON.stringify(obj[0]))
            var subMen = objsub.items.filter((e) => e.codigo == ele.codigo)[0]
            objsub.items = []
            objsub.items.push(subMen)
            CrearRow.push(objsub)
          }

          if (ObjCrearRow.length > 0) {
            var objsub = JSON.parse(JSON.stringify(obj[0]))
            var subMen = objsub.items.filter((e) => e.codigo == ele.codigo)[0]
            ObjCrearRow[0].items.push(subMen)
            ObjCrearRow[0].items.sort(function (a, b) {
              if (a.orden > b.orden) {
                return 1
              }
              if (a.orden < b.orden) {
                return -1
              }
              return 0
            })
          }
        })

        CrearRow.sort(function (a, b) {
          if (a.orden > b.orden) {
            return 1
          }
          if (a.orden < b.orden) {
            return -1
          }
          return 0
        })

        sessionStorage.setItem("itemsRouter", JSON.stringify(CrearRow))
        this.$store.commit("MutationDataRouter", CrearRow)
      },

      crearContabilidadPvNoexit() {
        this.$axios
          .get(this.$hostname + this.$hName + `/contabilidad/crearContabilidadPvNoexit/`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            console.log("res.data(CONT-CRE)---->", res.data)
          })
      },

      getFacturaeletronicaPendiente(){
      EventBus.$emit("getFacturaeletronicaPendiente")
      },
      

      alerta(e, l) {
        if (l == "bien") {
          ;(this.aalert.estado = true), (this.aalert.color = "success"), (this.aalert.nombre = e)

          this.NewRegistro()
          //this.new();
        }

        if (l == "error") {
          ;(this.aalert.estado = true), (this.aalert.color = "error"), (this.aalert.nombre = e)

          this.ejecucion = true
        }
      },
      getImgUrl() {
        var images = require("@/assets/img/Nofoto.png")
        return images
      },
      currencyFormatter(number) {
        //return this.formatNumber(params) + ".00";
        if (number == null) {
          number = 0
        }
        return number
          .toFixed(2)
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")

        ///return this.formatNumber(params);

        //return params;
      },
      CerrarSesion() {
        sessionStorage.setItem("ConfiguracionGeneral", JSON.stringify(null))
        this.$store.commit("MutationaddConfiguracionGeneral", null)

        sessionStorage.setItem("OtrasConfigPv", JSON.stringify(null))
        this.$store.commit("MutationDataOtrasConfigPv", null)

        sessionStorage.setItem("AuthorizationToken", JSON.stringify(null))
        this.$store.commit("MutationHeadersAxios", null)
        this.$store.commit("MutationHeadersTenant", null)
        this.$store.commit("MutationHeadersAxios", null)

        sessionStorage.setItem("Usuario", JSON.stringify(null))

        var rou = JSON.parse(JSON.stringify(this.$store.getters.GetDatosItemsRouterDefour))
        this.$store.commit("MutationDataRouter", null)
        sessionStorage.setItem("itemsRouter", JSON.stringify(null))

        this.$store.commit("MutationaddUser", null)
        sessionStorage.setItem("AuthorizationToken", JSON.stringify(null))
        this.$store.commit("MutationHeadersAxios", null)

        // this.$router.push({ path: '/' })
        // location.reload();
        // var _this=this;
        // setTimeout(function(){
        //   location.reload();
        //  }, 200);
      },
    },

    computed: {
      GetLogin() {
        this.$store.commit("MutationbtnAppBar", false)
        this.$store.commit("MutationActivarBarraAccion", false)
        if (this.windowSize.width < 600) {
          this.imgajust = 30
        } else {
          this.imgajust = 80
        }

        if (this.windowSize.height < 350) {
          this.sizeOnrefom = 0
          this.footerInfdeca = false
        } else {
          this.sizeOnrefom = 110
          this.footerInfdeca = true
        }
      },
    },
  }
</script>

<style lang="scss">
  #footInfo {
    // position: relative;
    /* bottom: 0; */
    //margin: 0  0 0 0;
    // clear: both;
    /* display: table-footer-group; */
    // width: 100%;
    /* top: 275%; */
    background: #1c2c35 url(../assets/147.png);
    // display: block;
    /* padding: 2em; */
    /* height: 3em; */
    //display: inline-table;
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }

  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @keyframes loader {
    from {
      transform: rotate(0);
    }

    to {
      transform: rotate(360deg);
    }
  }

  @media screen and (min-width: 1058px) {
    #bottomteclado {
      min-width: 160px;
    }
  }

  @media screen and (max-width: 1058px) {
    #bottomteclado {
      min-width: 100px;
    }
  }
</style>
